export default __webpack_public_path__ + "static/media/cancer_3x2_Hk.a9f8602c.webp";